import axios from "axios";
const AdminToken = `Bearer ` + localStorage.getItem('Sport_Admin_Token');

export let https = axios.create({
    headers : {
        Authorization: AdminToken,
        AccessControlAllowOrigin: '*',
        lang: localStorage.getItem('i18nextSportsLng'),
    }
})